import { render, staticRenderFns } from "./clinics.vue?vue&type=template&id=2719eb6b&"
import script from "./clinics.vue?vue&type=script&lang=js&"
export * from "./clinics.vue?vue&type=script&lang=js&"
import style0 from "./clinics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports